import { adminHttpClient } from '../../commons/adminHttpClient'

export type EligibleEmployeesWithoutFamilyStatusResponse = {
  companyUserId: string
  firstName: string
  lastName: string
}

const getEligibleEmployeesWithoutFamilyStatus = (
  planPeriodId: string,
): Promise<EligibleEmployeesWithoutFamilyStatusResponse[]> => {
  return adminHttpClient.get(`/Companies/EligibleEmployeesWithoutFamilyStatus/${planPeriodId}`)
}

export default getEligibleEmployeesWithoutFamilyStatus
